export default {
  'show-list': 'Liste',
  'show-map': 'Karte',
  'details': 'Details',
  'route-link': 'Route',
  'route-link.detail': 'Route berechnen',
  'map': 'Karte',
  'has-boxes': 'Verkauf von Hermes Verpackungen',
  'acceptsSuitcases': 'Reisegepäckannahme',
  'back': 'Zurück',

  'shoplist.info': {
    __html: 'Bitte weiter oben eine PLZ, einen Ort, und/oder eine Straße eingeben, in deren Umkreis eine Suche starten soll.'
  },

  'shoplist.no-reroute-shops': 'Es wurde kein wählbarer WunschPaketShop in der Nähe des gesuchten Ortes gefunden.',

  'business-hours.unknown': 'für diesen PaketShop liegen keine Öffnungszeiten vor.',
  'business-hours.closed': 'Geschlossen',

  'search': 'Suchen',
  'search.input-placeholder': 'Adresse, PLZ oder Ort eingeben',
  'search-criteria': 'Suchkriterien',
  'search.toggle-details': 'Standorte filtern',
  'search-detail.intro': 'Die angezeigten PaketShops können nach folgenden Kriterien eingegrenzt werden:',
  'search-detail.luggage.label': 'Reisegepäckabgabe',
  'search-detail.boxes.label': 'Verkauf von Hermes Verpackungen',
  'search-detail.apply': 'Filter anwenden',
  'search-detail.close': 'Schließen',

  'error.no-shops': {
    __html: 'Es wurden keine Paketshops in der gesuchten Umgebung gefunden.'
  },

  'error.address-resolve-failed': 'Die angegebene Adresse wurde nicht gefunden.',
  'error.position-resolve-failed': 'Die angegebene Position wurde nicht feunden.',

  'days.short.MON': 'Mo',
  'days.short.TUE': 'Di',
  'days.short.WED': 'Mi',
  'days.short.THU': 'Do',
  'days.short.FRI': 'Fr',
  'days.short.SAT': 'Sa',
  'days.short.SUN': 'So',
  'days.full.MON': 'Montag',
  'days.full.TUE': 'Dienstag',
  'days.full.WED': 'Mittwoch',
  'days.full.THU': 'Donnerstag',
  'days.full.FRI': 'Freitag',
  'days.full.SAT': 'Samstag',
  'days.full.SUN': 'Sonntag',
  'days.today': 'Heute',
  'days.tomorrow': 'Morgen',

  'time.preposition.UNTIL': 'bis',
  'time.preposition.BEFORE': 'vor',

  //paketParcelLock
  'search.paketParcelLock.note': 'Bitte beachten: ',
  'search.paketParcelLock.link-text': 'so funktioniert\'s',
  'search.paketParcelLock.link-url': 'https://www.myhermes.de/service/paketstation/',

  //paketParcelLock
  'details.benefits.paketParcelLock.list-1': 'Empfangen von Päckchen und Paketen',
  'details.benefits.paketParcelLock.list-2': 'Rückgabe von Online-Shop-Retouren',
  'details.benefits.paketParcelLock.list-3': 'Pakete schnell und einfach verschicken',
  'details.benefits.paketParcelLock.link-wrapper-text': 'Für weitere Infos besuchen Sie ',
  'details.benefits.paketParcelLock.link-text': 'www.hamburgbox.de/faq',
  'details.benefits.paketParcelLock.link-url': 'http://www.hamburgbox.de/faq',

  //paketParcelLock
  'details.hint.paketParcelLock.headline': 'Wichtiger Hinweis:',
  'details.hint.paketParcelLock.copy': 'Um diese Paketstation nutzen zu können, wird eine TAN zur Sendungsabholung benötigt.',
  'details.hint.paketParcelLock.link-text': ' So funktioniert\'s',
  'details.hint.paketParcelLock.link-url': 'https://www.myhermes.de/service/paketstation/',

  // Media markkt
  'details.hint.parcel-shop.media-markt.copy': 'In diesem Hermes-PaketShop können nur Privatsendungen mit einem online bezahlten Paketschein (über myHermes.de oder Hermes-App) abgegeben werden.',

  //paketParcelLock
  'callback-button.paketParcelLock.text': 'Paketstation übernehmen',

  //paketParcelLock
  'details.title.paketParcelLock': 'Paketstation',

  'details.title': 'Hermes PaketShop',
  'details.opening-hours': 'Öffnungszeiten',
  'details.opening-hours-today': 'Heutige Öffnungszeiten',
  'details.parcelShopNumber': 'PaketShop ID',

  'details.benefits.shipping': 'Versand von Päckchen und Paketen',
  'details.benefits.paketfuxx': 'Nachbarschaftsabgabe',
  'details.benefits.redirect': 'Alternative Zustelladresse',
  'details.benefits.pickup': 'Abholung mit Vollmacht',
  'details.benefits.retours': 'Rückgabe von Online-Shop-Retouren',
  'details.benefits.paketParcelLock-1': 'Empfangen von Päkchen und Paketen',
  'details.benefits.paketParcelLock-2': 'Kostenloser Rückversand von Retouren*',

  'details.on-holiday.note': 'Bitte beachten:',
  'details.on-holiday': 'Vom %from bis zum %to ist unser PaketShop geschlossen.',
  'details.on-holiday.short': 'Urlaub: %from - %to',
  'services': 'Leistungen',
  'callback-button.text': 'PaketShop übernehmen',
  'callback-button.unavailable': 'Dieser PaketShop ist leider nicht als WunschPaketShop wählbar.',

  'filter.luggage': 'Deutsche Bahn Reisegepäck',
  'filter.boxes': 'Hermes Verpackungen',
  'filter.time': 'Geöffnet $day %time',

  'time-filter.openToday': 'Heute geöffnet: ',
  'time-filter.closed': 'Öffnet um ',
  'time-filter.openedNextDay': 'Öffnet am ',
  'time-filter.opened': 'Geöffnet bis ',
  'time-filter.at': 'um',
  'time-filter.from': ' und ab ',
  'time-filter.clock': ' Uhr',
  'time-filter.openedFilter': 'Geöffnet ',

  'social-buttons.facebook': 'teilen',
  'social-buttons.twitter': 'tweet',
  'social-buttons.whatsapp': 'teilen',
  'social-buttons.email': 'mail',
  'social-buttons.print': 'drucken',

  'shop-list.title': 'PaketShops in der Nähe',
  'widget.headline': 'Suche PaketShop',
  'widget.input-placeholder': 'Adresse, PLZ, Ort',
  'widget.option-button': 'Weitere Optionen',
  'widget.submit-button': 'Suchen',
  'widget.open-on': 'Geöffnet am',

  'legal': 'Impressum',
  'security': 'Sicherheitshinweise',
  'privacy': 'Datenschutzerklärung',
  'cookies': 'Cookies',

  'legal.url': 'https://www.myhermes.de/impressum/',
  'security.url': 'https://www.myhermes.de/sicherheit/',
  'privacy.url': 'https://www.myhermes.de/datenschutz/',
  'cookies.url': '#uc-corner-modal-show',

  'cookie.text': 'Um unsere Webseite für dich optimal zu gestalten, verwenden wir Cookies.',
  'cookie.button-text': 'Ich stimme zu',
  'cookie.link-text': 'Mehr erfahren',
  'cookie.link-url': 'https://www.myhermes.de/datenschutz/',

  //UserCentrics Cookie Consent
  'usercentrics.info': 'Die Anzeige von PaketShops in der Nähe basiert auf Google Maps. Mit dem Klick auf "Karte aktivieren" stimme ich der Datenfreigabe an Google Maps zu.',
  'usercentrics.button': 'Karte aktivieren',
  'usercentrics.privacy-text': 'Datenschutz',
  'usercentrics.privacy-url': 'https://www.myhermes.de/datenschutz/',
  'usercentrics.impressum-text': 'Impressum',
  'usercentrics.impressum-url': 'https://www.myhermes.de/impressum/'
};
